export default {
  label: {
    title: 'Busca',
    search: 'Busca textual em publicações',
    tags: 'Selecione as tags',
    send: 'Enviar',
    clear: 'Limpar',
    requiredValue: 'Valor obrigatório',
    trashLabel: 'Limpar filtro',
    closeLabel: 'Fechar informações',
    filterLabel: 'Aplicar filtro',
    tooltip: {
      filterButton: 'Filtros',
    },
    rule: 'Deve conter pelo menos dois caracteres',
  },

  titles: {
    postedAt: 'Data do documento: ',
    tags: 'Classificações: ',
    text: 'Texto do documento: ',
  },

  infoLabel: 'Informações do formulário',
  closeLabel: 'Fechar informações',
  filter: 'Filtro',
  noPosts: 'Nenhum resultado encontrado para o filtro selecionado',
  viewLabel: 'Visualizar documento',
  searchTip: 'Utilize operadores booleanos AND(e), OR(ou), NOT(menos) para combinar vários termos. Para expressões, utilize texto livre. Para expressões utilize aspas("").</br>Os parênteses podem ser utilizados para agrupar expressões. Ex: (carro OR caminhões) AND vermelho.',

  faq: {
    title: 'O que é?',
    description: 'Formulário para pesquisa e visualização dos documentos desejados de acordo com o texto escrito pelo usuário.',
  },
  faq2: {
    title: 'Como utilizar?',
    description: 'Digite a palavra ou frase desejada e aperte o botão buscar.',
  },
  faq3: {
    title: 'Como redefinir o formulário?',
    description: 'Para limpar o formulário, clique no botão limpar. Quando uma importação é realizada com sucesso, o formulário redefine automaticamente.',
  },
  faq4: {
    title: 'O que acontece se a importação falhar?',
    description: 'Se uma importação falhar, uma mensagem de erro será exibida. Redefina o formulário, verifique as informações e tente novamente.',
  },
};
